/* Full-screen image viewer. No storefront state, cart actions or page zoom changes. */
(function () {
  'use strict';
  if (window.ProductLightbox2026) return;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(root, pageSwiper, state) {
    var modal = root.querySelector('.lightbox-modal');
    if (!modal || !window.ProductDialog) return function () {};
    var stage = modal.querySelector('.lightbox-main');
    var slides = Array.from(stage.querySelectorAll('.swiper-slide'));
    var images = slides.map(function (slide) { return slide.querySelector('img'); });
    var thumbs = Array.from(modal.querySelectorAll('.lightbox-thumb'));
    var rail = modal.querySelector('.lightbox-thumbs');
    var count = modal.querySelector('.lightbox-count');
    var current = modal.querySelector('[data-lightbox-current]');
    var zoomButton = modal.querySelector('[data-lightbox-zoom-toggle]');
    var options = { signal: state.controller.signal };
    var swiper = null;
    var index = 0;
    var frame = 0;
    var destroyed = false;
    var railPointer = null;
    var railDragged = false;
    var resizeObserver;
    var entranceTimer = 0;
    var displayWidths = new WeakMap();
    var lastPointerAt = -Infinity;
    var lastPointer = null;

    function finishEntrance() {
      clearTimeout(entranceTimer);
      delete modal.dataset.entering;
    }
    function enter() {
      finishEntrance();
      if (reducedMotion.matches) return;
      var visible = 0;
      var bounds = rail?.getBoundingClientRect();
      thumbs.forEach(function (button) {
        var box = button.getBoundingClientRect();
        var inView = bounds && box.right > bounds.left && box.left < bounds.right;
        button.style.setProperty('--lb-thumb-delay', (inView ? Math.min(visible++, 5) * 45 : 0) + 'ms');
        button.querySelector('img').loading = 'eager';
      });
      modal.dataset.entering = 'true';
      // Only the rail has an entrance. The shared image loader keeps its preview
      // visible immediately and fades the sharp source in when decoding finishes.
      entranceTimer = setTimeout(finishEntrance, 150 + Math.max(0, Math.min(visible - 1, 5)) * 45);
    }
    function resetGlow() {
      lastPointer = null;
      lastPointerAt = -Infinity;
      modal.style.removeProperty('--lb-glow-near');
    }
    function reactGlow(event) {
      if (!modal.open || reducedMotion.matches || event.pointerType === 'touch' || modal.dataset.zoomed === 'true') return;
      var now = performance.now();
      // Broad, sparse updates; no cursor-following spotlight or animation loop.
      if (now - lastPointerAt < 80 || (lastPointer && Math.hypot(event.clientX - lastPointer.x, event.clientY - lastPointer.y) < 24)) return;
      lastPointerAt = now;
      lastPointer = { x: event.clientX, y: event.clientY };
      var box = images[index].getBoundingClientRect();
      var distance = Math.hypot(event.clientX - box.left - box.width / 2, event.clientY - box.top - box.height / 2);
      var near = Math.max(0, 1 - distance / Math.max(1, Math.max(box.width, box.height)));
      modal.style.setProperty('--lb-glow-near', (Math.round(near * 8) / 8).toString());
    }

    function galleryPreview(image) {
      var n = images.indexOf(image);
      var candidates = root.querySelectorAll('.main-slider img[data-index="' + n + '"], .main-image img[data-index="' + n + '"], .stacked-thumbnails img[data-index="' + n + '"], [data-gallery-select="' + n + '"] img');
      var path = new URL(image.src, document.baseURI).pathname;
      var source = null;
      candidates.forEach(function (candidate) {
        if (!candidate.complete || !candidate.naturalWidth || !candidate.currentSrc) return;
        if (new URL(candidate.currentSrc, document.baseURI).pathname !== path) return;
        if (!source || candidate.naturalWidth > source.naturalWidth) source = candidate;
      });
      return source?.currentSrc;
    }
    function loadImage(image, retry, scale) {
      if (!image) return;
      // CSS width is untransformed: pinch/zoom must increase source resolution
      // once, and closing must restore the cached width without measuring a hidden dialog.
      var width = modal.open ? parseFloat(getComputedStyle(image).width) : displayWidths.get(image);
      if (width > 0) displayWidths.set(image, width);
      var sizes = width > 0 ? Math.ceil(width * (scale || 1)) + 'px' : image.sizes;
      image.fetchPriority = image === images[index] ? 'high' : 'low';
      if (!modal.open) { if (image.sizes !== sizes) image.sizes = sizes; return; }
      window.ThemeProductImages.load(image, { sizes: sizes, preview: galleryPreview(image) });
      if (retry) { const source = image.src; image.removeAttribute('src'); image.src = source; }
    }
    function imageState(image, failed) {
      var slide = image.closest('.swiper-slide');
      slide.classList.toggle('is-image-unavailable', failed);
      slide.querySelector('[data-lightbox-retry]').hidden = !failed;
      if (zoomButton && slide === slides[index]) zoomButton.disabled = failed;
    }
    images.forEach(function (image) {
      image.addEventListener('error', function () { imageState(image, true); }, options);
      image.addEventListener('load', function () { imageState(image, false); }, options);
    });
    function curve() {
      frame = 0;
      if (!modal.open || !rail) return;
      var bounds = rail.getBoundingClientRect();
      var depth = parseFloat(getComputedStyle(modal).getPropertyValue('--lb-arc')) || 0;
      // Use the visible rail, not total product count: long galleries keep their
      // tap targets and scroll naturally without a fixed maximum image count.
      thumbs.forEach(function (button) {
        var box = button.getBoundingClientRect();
        var x = Math.max(-1, Math.min(1, (box.left + box.width / 2 - bounds.left - bounds.width / 2) / Math.max(1, (bounds.width - box.width) / 2)));
        button.style.setProperty('--lb-offset', (depth * (1 - x * x)).toFixed(2) + 'px');
      });
    }
    function requestCurve() { if (!frame) frame = requestAnimationFrame(curve); }
    function revealThumb(animate) {
      if (!rail || !thumbs[index]) return;
      var button = thumbs[index];
      var target = rail.scrollLeft + button.getBoundingClientRect().left - rail.getBoundingClientRect().left - (rail.clientWidth - button.offsetWidth) / 2;
      rail.scrollTo({ left: Math.max(0, Math.min(target, rail.scrollWidth - rail.clientWidth)), behavior: animate && !reducedMotion.matches ? 'smooth' : 'instant' });
      requestCurve();
    }
    function updateZoom(scale) {
      var zoomed = scale > 1;
      modal.dataset.zoomed = String(zoomed);
      if (zoomed) { finishEntrance(); resetGlow(); }
      if (zoomButton) {
        zoomButton.setAttribute('aria-pressed', String(zoomed));
        zoomButton.querySelector('span').textContent = zoomed ? 'Zoom out' : 'Zoom in';
      }
      loadImage(images[index], false, scale);
    }
    function update() {
      if (!swiper) return;
      index = swiper.realIndex;
      slides.forEach(function (slide, n) { slide.inert = n !== index; slide.setAttribute('aria-hidden', String(n !== index)); });
      thumbs.forEach(function (button, n) { button.setAttribute('aria-current', String(n === index)); button.tabIndex = n === index ? 0 : -1; });
      current.textContent = String(index + 1).padStart(2, '0');
      count.setAttribute('aria-label', 'Image ' + (index + 1) + ' of ' + slides.length);
      images.forEach(function (image, n) { image.fetchPriority = n === index ? 'high' : 'low'; });
      if (zoomButton) zoomButton.disabled = slides[index].classList.contains('is-image-unavailable');
      updateZoom(swiper.zoom?.scale || 1);
      [index - 1, index + 1].forEach(function (n) { loadImage(images[n]); });
      revealThumb(false);
    }
    function select(next, focusThumb) {
      if (!swiper) return;
      finishEntrance();
      resetGlow();
      next = Math.max(0, Math.min(next, slides.length - 1));
      if (swiper.zoom?.scale > 1) swiper.zoom.out();
      swiper.slideTo(next, reducedMotion.matches ? 0 : 240);
      if (focusThumb) thumbs[next]?.focus({ preventScroll: true });
    }
    var viewer = window.ProductDialog.mount(modal, {
      open: function () {
        if (!swiper) {
          swiper = new Swiper(stage, {
            initialSlide: index, slidesPerView: 1, effect: 'fade', fadeEffect: { crossFade: true },
            speed: reducedMotion.matches ? 0 : 240,
            // The image browser has explicit ends, independent of carousel looping.
            loop: false, rewind: false, watchOverflow: true,
            zoom: { enabled: modal.dataset.lightboxZoom === 'true', maxRatio: 3, minRatio: 1, toggle: true },
            a11y: { enabled: false },
            on: {
              slideChange: function () { if (swiper) { finishEntrance(); resetGlow(); update(); } },
              zoomChange: function (_, scale) { updateZoom(scale); }
            }
          });
        }
        swiper.update();
        swiper.slideTo(index, 0);
        update();
        curve();
        enter();
      },
      close: function () {
        finishEntrance();
        resetGlow();
        if (!swiper) return;
        if (swiper.zoom?.scale > 1) swiper.zoom.out();
        updateZoom(1);
        if (destroyed || !pageSwiper || pageSwiper.destroyed) return;
        if (pageSwiper.params.loop) pageSwiper.slideToLoop(index, 0);
        else pageSwiper.slideTo(index, 0);
        return root.querySelector('.main-slider img[data-index="' + index + '"]')?.closest('[data-gallery-open]');
      }
    });
    function open(next, trigger) {
      if (modal.open) return;
      index = Math.max(0, Math.min(next, slides.length - 1));
      state.dragged = false;
      viewer.open(trigger);
    }
    root.addEventListener('click', function (event) {
      if (modal.contains(event.target)) return;
      if (event.detail > 0 && (state.dragged || pageSwiper?.allowClick === false)) return;
      var trigger = event.target.closest('[data-gallery-open]');
      var selected = !pageSwiper && event.target.closest('[data-gallery-select]');
      if (selected) open(Number(selected.dataset.gallerySelect), selected);
      if (trigger) {
        var image = trigger.matches('img') ? trigger : trigger.querySelector('img[data-index]');
        open(Number(image?.dataset.index || 0), trigger);
      }
    }, options);
    root.addEventListener('keydown', function (event) {
      var trigger = event.target.closest('img[data-gallery-open]');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); open(Number(trigger.dataset.index), trigger); }
    }, options);
    modal.addEventListener('click', function (event) {
      var thumb = event.target.closest('.lightbox-thumb');
      if (thumb && !railDragged) select(Number(thumb.dataset.lightboxIndex));
      if (event.target.closest('[data-lightbox-zoom-toggle]') && swiper?.zoom) {
        finishEntrance();
        if (swiper.zoom.scale > 1) swiper.zoom.out(); else swiper.zoom.in(2);
      }
      var retry = event.target.closest('[data-lightbox-retry]');
      if (retry) { imageState(images[index], false); loadImage(images[index], true); }
    }, options);
    if (modal.dataset.lightboxGlow === 'true' && modal.dataset.glowResponse === 'mouse') {
      modal.addEventListener('pointermove', reactGlow, { passive: true, signal: state.controller.signal });
      modal.addEventListener('pointerleave', resetGlow, options);
    }
    modal.addEventListener('keydown', function (event) {
      if (!swiper || !modal.open || event.altKey || event.ctrlKey || event.metaKey) return;
      var next;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = slides.length - 1;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index - 1;
      else if (zoomButton && !zoomButton.disabled && ['+', '=', '-'].includes(event.key)) {
        event.preventDefault();
        if (event.key === '-') swiper.zoom.out(); else swiper.zoom.in(2);
      }
      if (next !== undefined) { event.preventDefault(); select(next, !!event.target.closest('.lightbox-thumb')); }
    }, options);
    if (rail) {
      rail.addEventListener('scroll', requestCurve, { passive: true, signal: state.controller.signal });
      rail.addEventListener('pointerdown', function (event) { railDragged = false; railPointer = { x: event.clientX, y: event.clientY }; }, options);
      rail.addEventListener('pointermove', function (event) { if (railPointer && Math.hypot(event.clientX - railPointer.x, event.clientY - railPointer.y) > 8) railDragged = true; }, options);
      rail.addEventListener('pointerup', function () { railPointer = null; }, options);
      rail.addEventListener('pointercancel', function () { railPointer = null; railDragged = true; }, options);
      rail.addEventListener('keydown', function () { railDragged = false; }, options);
    }
    resizeObserver = new ResizeObserver(function () {
      if (!modal.open) return;
      loadImage(images[index], false, swiper?.zoom?.scale || 1);
      revealThumb(false);
    });
    resizeObserver.observe(stage);
    if (rail) resizeObserver.observe(rail);
    reducedMotion.addEventListener('change', function () {
      if (swiper) swiper.params.speed = reducedMotion.matches ? 0 : 240;
      if (reducedMotion.matches) { finishEntrance(); resetGlow(); }
    }, options);
    return function () {
      destroyed = true;
      finishEntrance();
      resetGlow();
      cancelAnimationFrame(frame);
      resizeObserver?.disconnect();
      viewer.destroy();
      if (swiper) swiper.destroy(true, true);
    };
  }
  window.ProductLightbox2026 = { mount: mount };
})();
